<div class="min-h-screen main-bg">
  @if (showMainNavbar) {
    <app-navbar></app-navbar>
  }

  <router-outlet></router-outlet>
</div>

@if (flow.step() !== 'closed') {
  <app-modal (close)="flow.close()">
    @if (flow.step() === 'start') {
      <app-start-investment-modal />
    }
    @if (flow.step() === 'otp') {
      <app-otp-modal />
    }
  </app-modal>
}

@if (showFooter) {
  <app-footer />
}


<a
  href="https://wa.me/201208122221"
  class="whatsapp-float"
  target="_blank"
>
  <i class="fab fa-whatsapp"></i>
</a>
